import React, { useEffect } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import CardImage from "./CardImage";
import HttpService from "../services/HttpService";
import { useQuery } from "@tanstack/react-query";
import CountDownTimer from "./CountDownTimer";
import Labels from "../labels/Labels";

const PanView = ({
  onTimeout,
  cardService,
  memberId,
  companyId,
  setDialogTitlePostMessage,
  setIsLoadingPanInfo,
}) => {
  const [btnDisplay, setBtnDisplay] = React.useState("block");
  const isMobile = useMediaQuery("(max-width:600px)");
  const [width, setWidth] = React.useState(window.innerWidth);
  const [height, setHeight] = React.useState(window.innerWidth);
  const [showTimer, setShowTimer] = React.useState(false);
  const [areModulesLoaded, setAreModulesLoaded] = React.useState(false);
  const [unmountHighnoteWidgetFunction, setUnmountHighnoteWidgetFunction] =
    React.useState(null);
  const [isHighnoteCardViewerLoaded, setIsHighnoteCardViewerLoaded] =
    React.useState(false);

  async function fetchProcesorData() {
    const response = await HttpService.getAxiosClient().get(
      window.API_URL +
        `/member/card-token?memberId=${memberId}&companyId=${companyId}`
    );
    return response;
  }

  const { data, isLoading, isFetching } = useQuery(
    ["member-card-token-info", memberId, companyId],
    () => fetchProcesorData()
  );

  const theme = useTheme();

  useEffect(() => {
    if (isMobile) {
      setWidth(320);
      setHeight(340);
    } else {
      setWidth(380);
      setHeight(340);
    }
  }, [isMobile]);

  const cardImage = CardImage();

  const callQoloWidget = (cardToken) => {
    const urlScript = window.ism_widget_url;

    const whenLoad = () => {
      const widget = {
        onLoadIframe: (iframe_loaded) => {},
        onSuccess: (details) => {
          setShowTimer(true);
        },
        onFailure: (details) => {},
        frame: {
          container_id: "widget_container",
          iframe_class: "widget-iframe",
          filter:
            "invert(27%) sepia(51%) saturate(2878%) hue-rotate(346deg) brightness(104%)",
        },
        target_origin: window.ism_target_origin,
        config: {
          token: cardToken,
          main: "show_pan",
          css: {
            container: {
              border: 0,
              margin: 0,
              overflowX: "hidden",
              padding: 0,
            },
            vc: {
              color: "black",
            },
            vc_bg: {
              "background-image": `url(${origin + cardImage})`,
            },
            vc_number: {
              top: "69%",
              left: "-10%",
              color: "white",
              "font-size": "16px",
            },
            vc_logo: {
              display: "none",
            },
            vc_network: {
              display: "none",
            },
            "btn-sm": {
              display: btnDisplay,
              color: "white",
              backgroundColor: "teal",
              borderRadius: "15px", // Add this line to round the border
              height: "40px",
              border: "none",
            },
            "mt-2": {
              display: "none",
            },
            vc_exp_date: {
              color: "white",
              left: "-5%",
              "font-size": "16px",
            },
            body: {},
            "col-12": {
              display: "none",
            },
          },
          content: {
            submit_text: Labels.getLabel("panView.show", "SHOW"),
          },
        },
      };

      const iframe = document.getElementById("widget_iframe");
      const pciWidget = iframe.contentWindow.pciWidget;
      pciWidget(widget);

      const widget_container =
        iframe.contentDocument.getElementById("widget_container");
      if (widget_container) {
        widget_container.style.width = `${width}px`;
        widget_container.style.height = `${height}px`;
        widget_container.style.overflow = "hidden";
      }

      const widget_frame =
        iframe.contentDocument.getElementById("widget_frame");
      if (widget_frame) {
        widget_frame.style.width = widget_container.style.width;
        widget_frame.style.height = widget_container.style.height;
        widget_frame.style.overflow = "hidden";
      }
    };

    const iframe = document.getElementById("widget_iframe");

    const script = document.createElement("script");
    script.src = urlScript;
    script.addEventListener("load", () => whenLoad());

    iframe.contentDocument.body.appendChild(script);
    const div = iframe.contentDocument.createElement("div");
    div.id = "widget_container";
    div.name = "widget_container";
    iframe.contentDocument.body.appendChild(div);

    return () => {};
  };
  //to load modules
  useEffect(() => {
    if (areModulesLoaded) return;
    if (!data?.data?.cardToken) return;
    if (data?.data?.processor !== "highnote") {
      setAreModulesLoaded(true);
      return;
    }
    setIsLoadingPanInfo(true);

    const script = document.createElement("script");
    script.type = "module";
    const url = window.highnote_widget_url;
    script.innerHTML = `
      import { renderFields } from "${url}";
      window.renderFields = renderFields;
    `;
    let widget_container = document.getElementById("widget_iframe");
    if (!widget_container) {
      widget_container = document.createElement("div");
      widget_container.id = "widget_container";
      document.body.appendChild(widget_container);
    }
    if (widget_container) {
      widget_container.style.width = `${width}px`;
      widget_container.style.height = `${height}px`;
      widget_container.style.overflow = "hidden";
    }

    const cardNumberDiv = document.createElement("div");
    cardNumberDiv.id = "cardNumber";
    cardNumberDiv.style.position = "absolute";
    cardNumberDiv.style.top = "210px";
    cardNumberDiv.style.left = "8.5rem";
    cardNumberDiv.style.zIndex = "1";
    cardNumberDiv.style.height = "20px";

    widget_container.appendChild(cardNumberDiv);
    const cvvDiv = document.createElement("div");
    cvvDiv.id = "cvv";

    cvvDiv.style.position = "absolute";
    cvvDiv.style.top = "240px";
    cvvDiv.style.left = "8.5rem";
    cvvDiv.style.zIndex = "1";
    cvvDiv.style.height = "20px";

    widget_container.appendChild(cvvDiv);
    const expirationDateDiv = document.createElement("div");
    expirationDateDiv.id = "expirationDate";
    expirationDateDiv.style.position = "absolute";
    expirationDateDiv.style.top = "230px";
    expirationDateDiv.style.left = "19.5rem";
    expirationDateDiv.style.zIndex = "1";
    expirationDateDiv.style.height = "20px";

    widget_container.appendChild(expirationDateDiv);
    const cardImageDiv = document.createElement("div");
    cardImageDiv.id = "cardImage";
    cardImageDiv.style.width = "340px";
    cardImageDiv.style.height = "210px";
    cardImageDiv.style.overflow = "hidden";
    cardImageDiv.style.position = "absolute";
    cardImageDiv.style.left = isMobile ? "2rem" : "7rem";
    cardImageDiv.style.zIndex = "0";

    widget_container.appendChild(cardImageDiv);
    widget_container.appendChild(script);
    // wait for the script to load
    const interval = setInterval(() => {
      if (window.renderFields) {
        clearInterval(interval);
        setAreModulesLoaded(true);
        setIsLoadingPanInfo(false);
      }
    }, 1000);
  }, [data?.data?.cardToken, data?.data?.processor]);

  const callHighnoteWidget = (cardToken, proxyId) => {
    if (isHighnoteCardViewerLoaded) return;
    if (!window.renderFields) return;
    (async () => {
      try {
        const { unmount, toggleCardNumberMask } = await window.renderFields({
          clientToken: cardToken,
          paymentCardId: proxyId,
          elements: {
            cardNumber: {
              selector: "#cardNumber",
              styles: {
                color:
                  theme?.palette?.cardText?.[cardService.cardDetail.brand]?.[
                    cardService.cardDetail.shortLabel
                  ] ||
                  theme?.palette?.cardText?.default ||
                  "white",
                fontSize: "16px",
              },
            },
            cvv: {
              selector: "#cvv",
              styles: {
                color:
                  theme?.palette?.cardText?.[cardService.cardDetail.brand]?.[
                    cardService.cardDetail.shortLabel
                  ] ||
                  theme?.palette?.cardText?.default ||
                  "white",
                fontSize: "14px",
              },
            },
            expirationDate: {
              selector: "#expirationDate",
              styles: {
                color:
                  theme?.palette?.cardText?.[cardService.cardDetail.brand]?.[
                    cardService.cardDetail.shortLabel
                  ] ||
                  theme?.palette?.cardText?.default ||
                  "white",
                fontSize: "16px",
              },
            },
          },

          onError: console.error,
          onReady: () => {
            toggleCardNumberMask();
            //onTimeout();
            setUnmountHighnoteWidgetFunction(() => unmount);
            setIsHighnoteCardViewerLoaded(true);
            setShowTimer(true);
            setDialogTitlePostMessage(
              Labels.getLabel(
                "panView.closeMessage",
                "The window will close in 20 seconds"
              )
            );
          },
        });
        const cardImageDiv = document.getElementById("cardImage");
        cardImageDiv.style.backgroundImage = `url(${origin + cardImage})`;
        cardImageDiv.style.backgroundSize = "cover";
        cardImageDiv.style.backgroundPosition = "center";
      } catch (err) {
        console.error(
          Labels.getLabel("panView.initFailed", "card-viewer init failed:"),
          err
        );
      }
    })();
  };

  React.useEffect(() => {
    if (!areModulesLoaded) return;
    if (data?.data?.cardToken)
      if (
        data?.data?.processor === undefined ||
        data?.data?.processor === "qolo"
      ) {
        callQoloWidget(data?.data?.cardToken);
      } else if (data?.data?.processor === "highnote") {
        callHighnoteWidget(data?.data?.cardToken, data?.data?.cardProxy);
      }
  }, [
    areModulesLoaded,
    data?.data?.cardToken,
    data?.data?.processor,
    window.renderFields,
  ]);

  React.useEffect(() => {
    return () => {
      if (unmountHighnoteWidgetFunction) {
        unmountHighnoteWidgetFunction();
      }
    };
  }, []);

  return (
    <>
      {data?.data?.processor === "highnote" ? (
        <div
          id="widget_iframe"
          style={{
            width: width + "50px",
            height: height + "px",
            display: "flex",
            justifyContent: "center",
            overflow: "hidden",
            margin: "auto",
          }}
        ></div>
      ) : (
        <iframe
          title="ViewPanWidget"
          id="widget_iframe"
          width={width + 10 + "px"}
          height={height}
          style={{
            border: "none",
            overflow: "hidden",
            margin: "auto",
            display: "block",
          }}
        ></iframe>
      )}

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "80vh",
          height: "2vh",
        }}
      >
        {showTimer && (
          <CountDownTimer
            duration={20}
            colors={["#ff9248", "#a20000"]}
            colorValues={[20, 10]}
            onComplete={() => onTimeout()}
            setDialogTitlePostMessage={setDialogTitlePostMessage}
          />
        )}
      </div>
    </>
  );
};

export default PanView;
